import { Typography } from "mobily-ui-library/lib";
import { useTranslation } from "react-i18next";
import Map from "../MapContainer/Map";
import EnteredCheck from "../EnteredCheck/EnteredCheck";
import NetworkCoverage from "../NetworkCoverage/NetworkCoverage";
import { useContext, useState } from "react";
import { coverageCheck } from "../../api/api";
import { GlobalContext } from "../../context/GlobalContext";
import Loader from "../Loader/Loader";
import { useWindowSize } from "../Util/WindowResize";
import { Error } from "../Util/Util";

import "./Home.scss";

interface Props {
  rtl: boolean;
}
const win: any = window;

function Home({ rtl }: Props) {
  const { t } = useTranslation();
  const [searchFlag, setSearchFlag] = useState<boolean>(false);
  const [mapValue, setMapValue] = useState("");
  const [coverageCheckData, setCoverageCheckData] = useState<Array<any>>([]);
  const [ecLoading, setECLoading] = useState(false);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const { state, dispatch }: any = useContext(GlobalContext);
  const [width, height] = useWindowSize();

  const handleAddress = (value: any, ltLg: any) => {
    setMapValue(value);
    setLat(ltLg.lat);
    setLng(ltLg.lng);
    dispatch({
      type: "CURRENT_MAP_VALUE",
      payload: { address: value, latLng: ltLg },
    });
  };

  const handleSearch = (param: boolean, latLng: any) => {
    setSearchFlag(param);
    setLat(latLng.lat);
    setLng(latLng.lng);

    if (latLng) {
      const { lat, lng } = latLng;
      setECLoading(true);

      coverageCheck({ lat, lon: lng }).then((res: any) => {
        setCoverageCheckData([]);
        if (res.status === 200 && res.data.data.coverageSections.length > 0) {
          setCoverageCheckData(res.data.data.coverageSections);
          setECLoading(false);
        } else {
          setECLoading(false);
          const errMsg = rtl
            ? res.data.status.arabicDetail
            : res.data.status.englishDetail;
          Error(errMsg);
          setTimeout(() => {
            window.location = win["errorPageURL"];
          }, 1000);
        }
      });
    }
  };

  return (
    <>
      <div className="container coverageCheck__container">
        <div className="row">
          <div className={rtl ? "coverageCheck arabic-text" : "coverageCheck"}>
            {!state.notifyMe && (
              <>
                <Typography className="coverageCheck__title" rtl={rtl}>
                  {t("CoverageCheck_title")}
                </Typography>

                <Typography className="coverageCheck__subtitle" rtl={rtl}>
                  {t("CoverageCheck_subtitle")}
                </Typography>
              </>
            )}

            {!searchFlag ? (
              <Map
                dispatch={dispatch}
                handleSearch={handleSearch}
                handleAddress={handleAddress}
                placeholder={t("Search")}
                mapValue={mapValue}
                rtl={rtl}
                t={t}
                width={width}
              />
            ) : (
              <EnteredCheck
                rtl={rtl}
                coverageCheckData={coverageCheckData}
                ecLoading={ecLoading}
                notifyMe={state.notifyMe}
                dimension={{ lat, lng }}
                dispatch={dispatch}
                handleSearch={handleSearch}
                handleAddress={handleAddress}
                address={mapValue}
              />
            )}
          </div>
        </div>
        {/*<div>
          <NetworkCoverage rtl={rtl} />
        </div>*/}
      </div>

      <Loader loading={state.loader} />
    </>
  );
}

export default Home;
